// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"page-template_tooltip__yp2C9"};